import type { AttachmentType } from 'src/__generated__/graphql';
import { apolloClient } from 'src/modules/graphql-client';
import { getValidationErrorMessages } from 'src/modules/graphql-client/errors';
import { getOperationNameFromQuery } from 'src/modules/utils';
import { addLogByKey } from 'src/utils/logger';

import { logError } from '../../modules/error-logger/browserLog';

import { PROCESS_UPLOADED_ATTACHMENT } from './process-uploaded-attachment.graphql';

export const processUploadedAttachment = ({
  attachmentId,
  attachmentType,
}: {
  attachmentId: string;
  attachmentType: AttachmentType;
}) =>
  apolloClient
    .mutate({
      mutation: PROCESS_UPLOADED_ATTACHMENT,
      variables: {
        input: {
          id: attachmentId,
          attachmentType,
        },
      },
      errorPolicy: 'all',
    })
    .catch((err: unknown) => {
      addLogByKey('process-uploaded-attachment-catch', {
        attachmentType,
        href: window.location.href,
        err,
      });

      logError(
        {
          ...(err as Error),
          type: 'process-uploaded-attachment',
        },
        {
          error: err,
          attachmentType,
          attachmentId,
          operationName: getOperationNameFromQuery(PROCESS_UPLOADED_ATTACHMENT),
        },
      );
      return null;
    })
    .then((res) => {
      const uri = res?.data?.processUploadedAttachment?.uri;

      const validationErrorMessages = getValidationErrorMessages(res);
      const firstValidationError = validationErrorMessages[0] || '';
      if (firstValidationError) {
        throw new Error(firstValidationError);
      }

      if (!uri) {
        throw new Error('Error uploading attachment');
      }

      return uri;
    });
